import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "src/components/ui/tooltip";
import { getDashboardInsightMetricGlossaryDetails } from "src/lib/dashboardInsights";
import { cn } from "src/lib/utils";

const getLabelText = (metric, children) => {
  if (typeof children === "string") return children;
  if (typeof metric === "string") return metric;
  return String(metric?.label || "");
};

export const MetricGlossaryLabel = ({
  children,
  className,
  metric,
  tooltipClassName,
}) => {
  const labelText = getLabelText(metric, children);
  const glossary = getDashboardInsightMetricGlossaryDetails(
    metric || labelText
  );
  const content = children ?? labelText;

  if (!glossary?.description) return <>{content}</>;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn(
            "inline max-w-full cursor-help rounded-sm border-0 bg-transparent p-0 text-left text-inherit underline decoration-dotted decoration-muted-foreground/35 underline-offset-2 transition-colors hover:decoration-muted-foreground/70 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary/35",
            className
          )}
        >
          {content}
        </button>
      </TooltipTrigger>
      <TooltipContent
        sideOffset={6}
        className={cn("max-w-80 text-xs", tooltipClassName)}
      >
        <span>{glossary.description}</span>
        {glossary.formula ? (
          <span
            data-slot="metric-glossary-formula"
            className="mt-1.5 block border-t border-border/50 pt-1.5 leading-snug text-muted-foreground"
          >
            Formula: {glossary.formula}
          </span>
        ) : null}
      </TooltipContent>
    </Tooltip>
  );
};
